import React from "react";
import styels from "./Footer.module.css";
import { HiOutlineMail } from "react-icons/hi";
import { FaTelegramPlane } from "react-icons/fa";
import logo from "../../assets/1213.png"

export const Footer = () => {
  return (
    <div className={styels.Footer} id="contact">
      <div className={styels.wrapper}>
        <div className={styels.logo}>
          <img src={logo} alt="WBM.company" />
        </div>
        <div className={styels.contact}>
          <a className={styels.a}href="mailto:wbm.company@mail.ru" rel="noreferrer" target="_blank">
            <HiOutlineMail className={styels.icon}/>
            wbm.company@mail.ru
          </a>
          <a className={styels.a}
            href="https://web.telegram.org/k/#@cammaler"
            rel="noreferrer"
            target="_blank"
          >
            <FaTelegramPlane className={styels.icon}/>
            Telegram
          </a>
        </div>
      </div>
    </div>
  );
};
